const translations = {
  // Navbar
  nav_home: 'Home',
  nav_shop: 'Loja',
  nav_whiskies: 'Whiskies',
  nav_gins: 'Gins',
  nav_about: 'Sobre',
  nav_our_story: 'Nossa História',
  nav_islay: 'Conheça Islay',
  nav_speyside: 'Speyside',
  nav_highlands: 'Highlands',
  nav_contact: 'Contato',
  nav_catalog: 'Ver Catálogo',

  // Hero
  hero_tagline: '',
  hero_title_1: 'A elegância que reside',
  hero_title_2: 'no Uísque Escocês',
  hero_subtitle: 'Whiskies e gins selecionados das três grandes regiões escocesas — Islay, Speyside e Highlands. Curadoria premium para paladares exigentes.',
  hero_cta_buy: 'Comprar Agora',
  hero_cta_whiskies: 'Ver Whiskies',
  hero_islay_sub: 'Turfa & Fumaça',
  hero_speyside_sub: 'Frutas & Mel',
  hero_highlands_sub: 'Complexidade',

  // Featured Products
  featured_label: 'Seleção Premium',
  featured_title: 'Produtos em Destaque',
  featured_see_all: 'Ver todos',

  // Regions
  regions_label: 'Nossa Especialidade',
  regions_title: 'Três Regiões. Uma Paixão.',
  regions_subtitle: 'Toda a nossa curadoria é focada nas três regiões escocesas que definem o que há de mais extraordinário no mundo dos destilados.',
  region_islay_subtitle: 'A Ilha da Turfa',
  region_islay_desc: 'No extremo sudoeste da Escócia, Islay produz os whiskies mais intensos e defumados do mundo. A turfa local, o ar marinho e os ventos atlânticos criam um caráter único — bruto, poético e inconfundível.',
  region_islay_char: 'Turfa · Fumaça · Sal Marinho · Iodo',
  region_islay_link: 'Conheça Islay',
  region_islay_accent: 'Defumado & Intenso',
  region_speyside_subtitle: 'O Vale do Spey',
  region_speyside_desc: 'Às margens do Rio Spey, a região mais densa em destilarias do mundo produz whiskies elegantes e frutados. Maçã, pera, mel e especiarias suaves definem o estilo que conquistou o mundo.',
  region_speyside_char: 'Frutas · Mel · Flores · Especiarias',
  region_speyside_link: 'Descubra Speyside',
  region_speyside_accent: 'Frutado & Elegante',
  region_highlands_subtitle: 'As Terras Altas',
  region_highlands_desc: 'A maior região produtora da Escócia abrange desde as costas do norte até as montanhas do sul. Whiskies de caráter robusto, complexo e encorpado — com notas de xeres, frutas escuras e especiarias orientais.',
  region_highlands_char: 'Xeres · Frutas Escuras · Especiarias · Carvalho',
  region_highlands_link: 'Explorar Highlands',
  region_highlands_accent: 'Encorpado & Complexo',
  region_see_whiskies: 'Ver Whiskies de',

  // Whiskies Section
  whiskies_label: 'Islay · Speyside · Highlands',
  whiskies_title: 'Whiskies Escoceses',
  whiskies_subtitle: 'Single malts selecionados das três regiões mais icônicas da Escócia — da turfa intensa de Islay ao mel elegante de Speyside e à complexidade das Highlands.',
  whiskies_see_all: 'Ver todos os whiskies',
  whiskies_islay_desc: 'Turfa intensa, fumaça marinha e sal atlântico. O caráter mais bruto e poético da Escócia.',
  whiskies_speyside_desc: 'Frutas maduras, mel de flores e especiarias suaves. A elegância que conquistou o mundo.',
  whiskies_highlands_desc: 'Xeres, frutas escuras e complexidade rara. A maior e mais diversa região escocesa.',
  whiskies_discover: 'Conhecer',

  // Gins Section
  gins_label: 'Destilados das Ilhas Escocesas',
  gins_title: 'Gins Escoceses',
  gins_subtitle: 'Gins artesanais produzidos nas destilarias de Islay, Speyside e Highlands — com botânicos locais, água de nascente e o terroir único da Escócia.',
  gins_see_all: 'Ver todos os gins',
  gins_banner_label: 'Experiência Premium',
  gins_banner_title: 'O Gin Perfeito para Cada Ocasião',
  gins_banner_subtitle: 'Gins produzidos com a água pura das nascentes de Islay, Speyside e Highlands — o terroir escocês em cada gole.',
  gins_explore: 'Explorar Gins',

  // Brand Section
  brand_label: 'Nossa Missão',
  brand_title_1: 'Das Destilarias de Islay,',
  brand_title_2: 'Speyside e Highlands',
  brand_title_3: 'Para o Seu Copo',
  brand_desc_1: 'A Ma Gádeni nasceu da paixão pelas três regiões mais icônicas da Escócia. Selecionamos pessoalmente cada rótulo — da turfa bruta de Islay ao mel elegante de Speyside e à complexidade das Highlands — para trazer ao Brasil o que há de mais sofisticado no mundo dos destilados escoceses.',
  brand_desc_2: 'Cada garrafa conta a história de uma ilha, de um vale, de uma montanha. Cada gole é uma viagem à Escócia.',
  brand_authenticity: 'Autenticidade',
  brand_rarity: 'Raridade',
  brand_curation: 'Curadoria',
  brand_link: 'Conheça nossa história',

  // Newsletter
  newsletter_label: 'Continue Conectado',
  newsletter_title: 'Assine a Nossa Newsletter',
  newsletter_subtitle: 'Receba novidades, lançamentos exclusivos e histórias do mundo dos destilados raros.',
  newsletter_placeholder: 'Seu e-mail',
  newsletter_btn: 'Inscreva-se',
  newsletter_success: 'Obrigado! Você foi inscrito com sucesso.',
  newsletter_error: 'Ocorreu um erro. Tente novamente.',

  // Footer
  footer_tagline: 'Das destilarias do Mundo, para o litoral sob o Sol',
  footer_contact: 'Fale Conosco',
  footer_about: 'Sobre Nós',
  footer_whiskies: 'Nossos Whiskeys',
  footer_rights: '© 2025 Ma Gádeni. All rights reserved',

  // Our Story
  story_hero_tagline: 'Das Destilarias do Mundo para o Litoral Sob o Sol: Uma Jornada de Espíritos Raros.',
  story_hero_title: 'Nossa História',
  story_breadcrumb_home: 'Início',
  story_hero_desc: 'Descubra a Ma Gádeni, um santuário de uísques raros no Nordeste brasileiro. Nascida de uma parceria única, curadamos maltes single raros da Escócia e outros destilados extraordinários para o colecionador exigente.',
  story_essence_title: 'A Essência da Ma Gádeni',
  story_essence_p1: 'Ma Gádeni, \'os jardins\' em Chichewa, é mais que um nome; é a nossa filosofia. Representa um santuário onde coisas de beleza e raridade são cultivadas para florescer. Nosso santuário está no coração de Natal, Brasil — uma serena chácara onde a energia vibrante do Nordeste encontra a alma atemporal dos mais finos uísques do mundo.',
  story_essence_p2: 'Embora nosso coração e fundamento estejam nos maltes single escoceses marcados pelo turf, nossa paixão se estende a todo o mundo da destilação excepcional. Somos guardiões da raridade. Nossa missão é buscar os uísques mais exclusivos, de edição limitada e descontinuados — primariamente das remotas destilarias da Escócia, mas também incluindo outras descobertas notáveis que contam uma história única. Importamos em quantidades mínimas, garantindo que cada garrafa que oferecemos não seja apenas uma bebida, mas um pedaço da história, uma narrativa em um copo.',
  story_promise_label: 'A Promessa Ma Gádeni: Procedência e Legado',
  story_promise_quote: 'Operamos com um princípio simples e intransigente: qualidade acima da quantidade.',
  story_trio_title: 'Nosso Trio Improvável',
  story_trio_subtitle: 'As Raízes de Um Sonho',
  story_trio_desc: 'A Ma Gádeni nasceu da confluência de três mundos, uma parceria tão única quanto os uísques que o cherizamos.',
  story_leda_role: 'A Alma do Seridó',
  story_leda_bio: 'Com raízes na histórica cidade de Caicó e tendo feito de Natal sua casa por grande parte de sua vida adulta, Leda personifica o rico tapete cultural do Rio Grande do Norte. Ela é o coração do nosso empreendimento, possuindo uma compreensão inata do paladar regional para celebração e sofisticação. Foi sua visão criar uma experiência de luxo incomparável no Nordeste, trazendo o melhor do mundo para o nosso cantinho do Brasil.',
  story_thomas_role: 'O Guardião da Tradição',
  story_thomas_bio: 'Com uma paixão de toda a vida pela água da vida — uisge-beatha — Thomas é nosso conhecedor e contador de histórias. Seu profundo conhecimento das destilarias escocesas e seu respeito pela arte do destilador lhe permitem buscar aquelas joias escondidas que escapam do mainstream. Ele é a ponte, conectando os vales neblinosos da Escócia à terra ensolarada da nossa chácara.',
  story_jade_role: 'A Nova Geração',
  story_jade_bio: 'A filha de Thomas, Jade, representa o futuro. Com um olhar moderno e um profundo respeito pelo legado que estamos construindo, ela entrelaça as ricas narrativas dos nossos uísques com o estilo de vida brasileiro contemporâneo. Ela garante que a história da Ma Gádeni não seja apenas preservada, mas evoluída.',
  story_closing: 'Juntos, somos uma família. Acreditamos que os melhores prazeres da vida são aqueles compartilhados e que as melhores histórias são contadas sobre uma bebida verdadeiramente excepcional.',
  story_explore_label: 'Pronto para Explorar Nossa Coleção Curada?',
  story_explore_desc: 'Descubra os atuais maltes single raros e outros uísques excepcionais que encontraram sua casa temporária em nossa chácara.',
  story_contact_us: 'Fale Conosco',
  story_pillar1_label: 'Uma Experiência, Não Apenas uma Compra',
  story_pillar1_desc: 'Quando você adquire um uísque da Ma Gádeni, está adquirindo um pedaço de uma jornada — de uma renomada destilaria escocesa ou de uma oficina escondida em outro lugar do mundo, para nossos tranquilos jardins brasileiros e, finalmente, para o seu copo.',
  story_pillar2_label: 'Um Santuário Curado:',
  story_pillar2_desc: 'Não trabalhamos com bebidas do mercado massificado. Nossa coleção principal é construída sobre maltes single escoceses raros, selecionados à mão por seu caráter único, idade e história.',
  story_pillar3_label: 'Uma Jornada Pessoal:',
  story_pillar3_desc: 'Cada importação é uma missão pessoal. Construímos relacionamentos com destiladores e corretores, garantindo autenticidade e exclusividade para nossos clientes.',
  story_form_title: 'Fale Conosco',
  story_form_label: 'Entre em Contato',
  story_form_desc: 'Gostaria de saber mais sobre nossos rótulos exclusivos? Preencha o formulário ao lado e retornaremos em breve.',
  story_form_location: 'Local',
  story_form_location_val: 'Natal — RN',
  story_form_provenance: 'Procedência',
  story_form_provenance_val: 'Importações selecionadas',
  story_form_hours: 'Atendimento',
  story_form_hours_val: 'Segunda à Sexta, 9h–18h',
  story_form_quote: '"Cada garrafa conta uma história. Deixe-nos contar a sua."',
  story_form_success: 'Mensagem enviada!',
  story_form_success_sub: 'Retornaremos em breve.',
  story_form_name: 'Nome Completo',
  story_form_phone: 'Telefone',
  story_form_email: 'E-mail',
  story_form_interest: 'Você Possui Interesse em:',
  story_form_message: 'Como Podemos Te Ajudar?',
  story_form_send: 'Enviar Mensagem',
  story_form_sending: 'Enviando...',

  // Contact
  contact_hero_tagline: 'Ma Gádeni · Natal, RN',
  contact_hero_title: 'Fale Conosco',
  contact_breadcrumb_home: 'Início',
  contact_location_label: 'Localização',
  contact_location_val: 'Natal — RN, Brasil',
  contact_location_sub: 'Chácara particular',
  contact_hours_label: 'Atendimento',
  contact_hours_val: 'Seg – Sex, 9h às 18h',
  contact_hours_sub: 'Horário de Brasília',
  contact_provenance_label: 'Procedência',
  contact_provenance_val: 'Importações selecionadas',
  contact_provenance_sub: 'Escócia · Irlanda · Mundo',
  contact_map_label: 'Onde Estamos',
  contact_map_title: 'Natal, Rio Grande do Norte',
  contact_social_label: 'Siga-nos',
  contact_form_label: 'Envie uma Mensagem',
  contact_form_title: 'Entre em Contato',
  contact_form_success: 'Mensagem enviada!',
  contact_form_success_sub: 'Obrigado pelo contato. Retornaremos em breve, dentro do horário de atendimento.',
  contact_form_new: 'Nova Mensagem',
  contact_form_name: 'Nome Completo',
  contact_form_phone: 'Telefone',
  contact_form_email: 'E-mail',
  contact_form_interest: 'Interesse em:',
  contact_form_message: 'Como Podemos Te Ajudar?',
  contact_form_send: 'Enviar Mensagem',
  contact_form_sending: 'Enviando...',
  contact_form_error: 'Ocorreu um erro. Por favor, tente novamente.',
  contact_cta_label: 'Explore Nossa Coleção',
  contact_cta_title: 'Das Destilarias do Mundo para o Seu Copo',
  contact_cta_desc: 'Descubra maltes single raros de Islay, Speyside e Highlands — selecionados com paixão e importados em quantidades mínimas para o Nordeste brasileiro.',
  contact_cta_btn: 'Ver Catálogo',
  contact_cta_story: 'Nossa História',

  // Shop / Whiskies / Gins pages
  shop_title: 'Nossa Loja',
  shop_featured: 'Destaques',
  shop_price_asc: 'Menor Preço',
  shop_price_desc: 'Maior Preço',
  shop_name_az: 'A–Z',
  shop_category: 'Categoria',
  shop_all: 'Todos',
  shop_whiskies: 'Whiskies',
  shop_gins: 'Gins',
  shop_empty: 'Nenhum produto encontrado.',
  shop_clear: 'Limpar filtros',
  shop_buy: 'Comprar',
  shop_hero_label: 'Ma Gádeni',

  whiskies_page_label: 'Categoria Premium',
  whiskies_page_title: 'Whiskies',
  whiskies_page_subtitle: 'Das turbulentas costas de Islay às suaves colinas de Speyside — os melhores single malts e blends do mundo.',
  whiskies_page_empty: 'Nenhum whisky encontrado com esses filtros.',
  whiskies_page_clear: 'Limpar filtros',
  whiskies_region_all: 'Todas',
  whiskies_style_all: 'Todos',
  whiskies_style_label: 'Estilo',

  gins_page_label: 'Categoria Premium',
  gins_page_title: 'Gins',
  gins_page_subtitle: 'Do clássico London Dry aos contemporâneos florais e especiados — gins de caráter para momentos únicos.',
  gins_page_empty: 'Nenhum gin encontrado com esses filtros.',
  gins_page_clear: 'Limpar filtros',
  gins_origin_label: 'Origem',
  gins_origin_all: 'Todas',
  gins_style_all: 'Todos',

  // Islay page
  islay_about: 'Sobre',
  islay_title: 'Conheça Islay',
  islay_island: 'A Ilha',
  islay_h2: 'A Alma Indomável do Whisky Escocês',
  islay_p1: 'Islay é uma ilha remota na costa oeste da Escócia, varrida pelos ventos do Atlântico e coberta por vastas turfeiras. Com apenas 3.000 habitantes, ela abriga algumas das destilarias mais lendárias do mundo — e produz whiskies que são inconfundíveis em qualquer degustação.',
  islay_p2: 'O caráter único dos whiskies de Islay vem da turfa — uma camada de matéria orgânica decomposta que cobre grande parte da ilha. Quando queimada para secar a cevada maltada, ela libera uma fumaça densa e aromática que impregna o grão com sabores profundos de defumado, iodo, sal marinho e alcatrão.',
  islay_video_title: 'Veja Islay em Todo o seu Esplendor',
  islay_distilleries_label: 'Destilarias',
  islay_distilleries_title: 'As Lendas de Islay',
  islay_peat_label: 'O Segredo',
  islay_peat_title: 'A Magia na Fumaça: Onde o Sabor é Forjado',
  islay_peat_p1: 'A genialidade do uísque de Islay está em uma única etapa transformadora. Para parar a germinação da cevada, os destiladores a secam sobre o fogo da turfa smolderante. A fumaça espessa e aromática não apenas seca o grão — ela o satura, impregnando-o com o caráter profundo e complexo da própria ilha.',
  islay_peat_p2: 'O nível de defumação é medido em PPM (partes por milhão de fenol). Enquanto um whisky comum tem menos de 5 PPM, os whiskies de Islay podem chegar a 50, 100 ou até mais de 200 PPM no caso do Octomore.',

  // Speyside page
  speyside_about: 'Sobre',
  speyside_title: 'Descubra Speyside',
  speyside_region: 'A Região',
  speyside_h2: 'A Elegância que Reside no Uísque Escocês',
  speyside_p1: 'Para entender Speyside, deixe de lado as noções de tempestades costeiras e turfa defumada. Viaje, em vez disso, para os vales suaves e ondulados do coração da Escócia. Aqui, protegida por colinas antigas e alimentada por rios puros e de água macia, encontra-se uma região onde a fabricação de uísque é uma arte de refinamento, não de resistência.',
  speyside_p2: 'Aninhadas nestes vales férteis, as destilarias de Speyside são abençoadas com um clima mais ameno. Este ambiente é a chave para o seu caráter. Sem a necessidade de fumaça de turfa pungente, os destiladores aqui se concentram na expressão pura e limpa da própria cevada.',
  speyside_char_label: 'Perfil Sensorial',
  speyside_char_title: 'O Caráter de Speyside',
  speyside_char_desc: 'Os whiskies de Speyside são reconhecidos mundialmente por sua elegância, complexidade e acessibilidade. Conheça os sabores que definem esta região extraordinária.',
  speyside_dist_label: 'Destilarias',
  speyside_dist_title: 'Os Grandes Nomes de Speyside',
  speyside_cta_title: 'Fale com um especialista agora',
  speyside_cta_desc: 'Nossa equipe está pronta para ajudá-lo a encontrar o whisky de Speyside perfeito para o seu paladar e ocasião.',
  speyside_cta_btn: 'Fale Conosco',

  // Product card badges & category
  badge_best_seller: 'Mais Vendido',
  badge_new: 'Novo',
  badge_premium: 'Premium',
  badge_cask_strength: 'Cask Strength',
  badge_classic: 'Clássico',
  badge_exclusive: 'Exclusivo',
  badge_limited: 'Edição Limitada',
  badge_navy: 'Navy Strength',
  badge_imported: 'Importado',
  card_cat_whisky: 'Whisky',
  card_cat_gin: 'Gin',

  // Product page
  product_not_found: 'Produto não encontrado',
  product_back_shop: 'Voltar à loja',
  product_cat_whisky: 'Whisky Premium',
  product_cat_gin: 'Gin Artesanal',
  product_spec_age: 'Idade',
  product_spec_abv: 'Teor Alc.',
  product_spec_origin: 'Origem',
  product_spec_style: 'Estilo',
  product_price: 'Preço',
  product_tax: 'Impostos inclusos',
  product_add_cart: 'Adicionar ao Carrinho',
  product_added: 'Adicionado!',
  product_buy_now: 'Comprar Agora',
  product_trust_auth: 'Produto Autêntico',
  product_trust_ship: 'Entrega Segura',
  product_trust_quality: 'Qualidade Garantida',
  product_description: 'Descrição',
  product_read_more: 'Ler mais',
  product_read_less: 'Ler menos',
  product_tasting: 'Notas de Degustação',
  product_nose: 'Nariz',
  product_palate: 'Paladar',
  product_finish: 'Final',
  product_awards: 'Prêmios & Reconhecimentos',
  product_related_label: 'Você Também Pode Gostar',
  product_related_title: 'Produtos Relacionados',
  product_see_all: 'Ver todos',

  // Highlands page
  highlands_about: 'Sobre',
  highlands_title: 'Highlands',
  highlands_largest: 'A Maior Região',
  highlands_h2: 'Onde a Pureza é Destilada em Lenda',
  highlands_p1: 'As Highlands formam a maior e mais diversa região produtora de uísque da Escócia, abrangendo tanto o continente quanto várias ilhas famosas. Por isso, produzem alguns dos uísques mais marcantes e lendários do mundo.',
  highlands_p2: 'Cada sub-região carrega uma identidade própria, moldada pelo clima severo, pela geografia isolada e pela pureza de suas águas. Os uísques não seguem um único estilo — eles vão dos mais leves e frutados aos mais intensos, salinos e levemente enfumaçados.',
  highlands_sub_label: 'Sub-regiões',
  highlands_sub_title: 'A Diversidade das Highlands',
  highlands_dist_label: 'Destilarias',
  highlands_dist_title: 'Ícones das Highlands',
  highlands_cta_title: 'Explore os Whiskies das Highlands',
  highlands_cta_desc: 'Descubra nossa seleção curada de expressões raras das Highlands, escolhidas com paixão e expertise pela equipe Ma Gádeni.',
  highlands_cta_btn: 'Ver Catálogo',
};

export default translations;
